<template>
  <div>
    <div class="main-layout">
      <Header />
      <slot />
      <!-- <Footer /> -->
    </div>
    <Footer />
  </div>
</template>

<style src="@/assets/css/common.css"></style>
<style src="@/assets/css/company.css" scoped></style>


<script>
import Header from "@/components/layout/company/Header.vue";
import Footer from "@/components/layout/company/Footer.vue";
import $ from "jquery";
import 'vue2-datepicker/index.css';

export default {
  name: "MainLayout",
  components: {
    Header,
    Footer
  },

  methods: {
    setupAnimationObserver() {
      const targetSection = document.querySelector('.footer-cta-section');
      const mockupContainer = document.querySelector('.cta-mockup-col');

      if (targetSection && mockupContainer) {
        mockupContainer.classList.remove('start-animation');

        const observerOptions = {
          root: null,
          rootMargin: "0px 0px -40% 0px",
          threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              mockupContainer.classList.add('start-animation');
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        observer.observe(targetSection);
      }
    },
  },

  mounted() {
    $(function() {
      $("#page_top").click(function() {
        $("html, body").animate({
          scrollTop: 0
        });
        return false;
      });
    });

    $(document).ready(function() {
      $(window).scroll(function() {
        var top = $(window).scrollTop();
        if (top == 0) {
          $("#page_top").css("display", "none");
        } else {
          $("#page_top").css("display", "block");
        }
      });

      $(window).scroll(function() {
        var menuHeight = $(".logo_sec").height();
        if ($(this).scrollTop() >= menuHeight) {
          $("header").addClass("add_bg");
        } else {
          $("header").removeClass("add_bg");
        }
      });
    });

    $(document).ready(function() {
      $(window)
        .resize(function() {
          var windowWidth = $(window).width();
          if (windowWidth < 768) {
            $("#menu_btn").click(function() {
              $(".hide_menu").toggle();
              if ($(this).hasClass("menu_active")) {
                $(this).removeClass("menu_active");
              } else {
                $(this).addClass("menu_active");
              }
            });
            $(".dropdown a").click(function() {
              $(this)
                .next("ul")
                .toggle();
              if (
                $(this)
                  .parent()
                  .hasClass("active")
              ) {
                $(this)
                  .parent()
                  .removeClass("active");
              } else {
                $(this)
                  .parent()
                  .addClass("active");
              }
            });
          } else {
            $("#menu_btn").unbind();
            $(".dropdown a").unbind();
          }
        })
        .resize();
    });
    
    this.setupAnimationObserver();
  }
};
</script>